import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import ErrorComponent from "./Error";

export default function DashboardError(): React.ReactNode {
  return (
    <Dashboard>
      <ErrorComponent />
    </Dashboard>
  );
}
